import { Box, CircularProgress } from '@mui/material'
import React, { memo, useEffect } from 'react'
import VodAssetTypeView from '../../components/itemDetails/vodAssetType/VodAssetTypeView'

import { getVodItemDetailsPageStyles } from '@/features/VOD/styles/VodItemDetailsPageStyles'
import { useVodItemDetailsPage } from '@/features/VOD/VodItemDetailsPage/hooks/useVodItemDetailsPage'
import { ErrorFallback } from '@/shared/ui'
import { ErrorBoundary } from 'react-error-boundary'

import { BackButtonComponent } from '@/features/VOD/components/itemDetails/BackButton'
import {
    FocusContext,
    useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'
import { VOD_DETAILS_PAGE_FOCUS_KEY } from '@/shared/constants/focusLibraryConstants'

const VodItemDetailsPage = memo(() => {
    const {
        shouldShowError,
        handleBackButtonClick,
        details,
        assetType,
        selectedVOD,
        isVodDetailsPageRendered,
    } = useVodItemDetailsPage()

    const { spinnerContainerStyle, contentStyles, mainContainerStyle } =
        getVodItemDetailsPageStyles()

    const { ref, focusKey, focusSelf } = useFocusable({
        focusKey: VOD_DETAILS_PAGE_FOCUS_KEY,
        focusable: true,
        forceFocus: true,
    })

    useEffect(() => {
        focusSelf()
    }, [isVodDetailsPageRendered])

    return (
        <FocusContext.Provider value={focusKey}>
            <Box position="relative" ref={ref}>
                <BackButtonComponent callback={handleBackButtonClick} />
                <ErrorBoundary FallbackComponent={ErrorFallback}>
                    {shouldShowError ? (
                        <ErrorFallback />
                    ) : (
                        <>
                            {details && assetType ? (
                                <Box sx={mainContainerStyle}>
                                    <Box
                                        sx={contentStyles}
                                        pt={selectedVOD ? 0 : '100px'}>
                                        <VodAssetTypeView
                                            assetType={assetType}
                                            details={details}
                                        />
                                    </Box>
                                </Box>
                            ) : (
                                <Box sx={spinnerContainerStyle}>
                                    <CircularProgress />
                                </Box>
                            )}
                        </>
                    )}
                </ErrorBoundary>
            </Box>
        </FocusContext.Provider>
    )
})

VodItemDetailsPage.displayName = 'VodItemDetailsPage'

export default VodItemDetailsPage
